<template>
  <div class="page-content">
    <div class="container py-12">
      <!-- 蓝色my-banner -->
      <div class="my-banner">
        <div class="my-banner-content max-w-3xl mx-auto">
          <h1 class="text-4xl md:text-5xl font-bold mb-4">会议厅方案推荐</h1>
          <p class="text-xl text-blue-100 max-w-2xl mx-auto">根据您的需求，我们为您精选了以下会议厅方案，满足不同规模和类型的活动需求。</p>
        </div>
      </div>

      <!-- 顶部筛选区 -->
      <div class="bg-white p-8 rounded-xl shadow-sm mb-12">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <h2 class="text-xl font-semibold text-gray-800 mb-2">选择活动人数</h2>
            <p class="text-gray-500 text-sm">根据您的活动规模，我们为您推荐最合适的会议厅方案</p>
          </div>

          <div class="flex flex-wrap gap-4">
            <button class="capacity-btn">100人</button>
            <button class="capacity-btn">300人</button>
            <button class="capacity-btn active">500人</button>
            <button class="capacity-btn">1000人</button>
          </div>
        </div>
      </div>

      <!-- 方案展示区 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <!-- 方案一 -->
        <div class="card">
          <div class="image-container">
            <img src="../assets/images/fatj/dgnt-img2.jpeg" alt="大宴会厅A" class="w-full h-full object-cover">
          </div>
          <div class="p-6 flex flex-col">
            <div class="card-header">
              <div class="card-title">方案一</div>
              <span class="badge">推荐方案</span>
            </div>

            <div class="space-y-4 my-6">
              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-file-alt"></i>
                </div>
                <div>
                  <div class="font-medium">半课桌式</div>
                </div>
              </div>

              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-door-open"></i>
                </div>
                <div>
                  <div class="font-medium">大宴会厅A</div>
                  <div class="text-sm text-gray-500">主会场区域，豪华装修</div>
                </div>
              </div>

              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-expand-arrows-alt"></i>
                </div>
                <div>
                  <div class="font-medium">1620平方米</div>
                  <div class="text-sm text-gray-500">空间宽敞，适合大型活动</div>
                </div>
              </div>
            </div>

            <div class="border-t border-gray-100 pt-4 mb-6">
              <div class="flex flex-wrap gap-2">
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">课桌式</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">高清投影</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">音响系统</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">高速WiFi</span>
              </div>
            </div>

            <div class="price-tag">13万元/半天</div>
          </div>
        </div>

        <!-- 方案二 -->
        <div class="card">
          <div class="image-container">
            <img src="../assets/images/fatj/dkz-img1.jpeg" alt="多功能厅" class="w-full h-full object-cover">
          </div>
          <div class="p-6 flex flex-col">
            <div class="card-header">
              <div class="card-title">方案二</div>
            </div>

            <div class="space-y-4 my-6">
              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-file-alt"></i>
                </div>
                <div>
                  <div class="font-medium">全课桌式</div>
                </div>
              </div>

              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-door-open"></i>
                </div>
                <div>
                  <div class="font-medium">多功能厅</div>
                  <div class="text-sm text-gray-500">专业演出级会议厅</div>
                </div>
              </div>

              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-expand-arrows-alt"></i>
                </div>
                <div>
                  <div class="font-medium">1200平方米</div>
                  <div class="text-sm text-gray-500">阶梯式座椅，专业舞台设备</div>
                </div>
              </div>
            </div>

            <div class="border-t border-gray-100 pt-4 mb-6">
              <div class="flex flex-wrap gap-2">
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">剧院式</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">专业音响</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">灯光系统</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">LED屏幕</span>
              </div>
            </div>

            <div class="price-tag">7.6万元/半天</div>
          </div>
        </div>

        <!-- 方案三 -->
        <div class="card">
          <div class="image-container">
            <img src="../assets/images/fatj/img3.jpeg" alt="309AB厅" class="w-full h-full object-cover">
          </div>
          <div class="p-6 flex flex-col">
            <div class="card-header">
              <div class="card-title">方案三</div>
              <span class="badge">经济之选</span>
            </div>

            <div class="space-y-4 my-6">
              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-file-alt"></i>
                </div>
                <div>
                  <div class="font-medium">剧院式</div>
                </div>
              </div>

              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-door-open"></i>
                </div>
                <div>
                  <div class="font-medium">309AB厅</div>
                  <div class="text-sm text-gray-500">组合式会议厅</div>
                </div>
              </div>

              <div class="flex items-center gap-3">
                <div class="feature-icon">
                  <i class="fas fa-expand-arrows-alt"></i>
                </div>
                <div>
                  <div class="font-medium">900平方米</div>
                  <div class="text-sm text-gray-500">紧凑型布局，灵活性高</div>
                </div>
              </div>
            </div>

            <div class="border-t border-gray-100 pt-4 mb-6">
              <div class="flex flex-wrap gap-2">
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">剧院式</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">基础音响</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">投影设备</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">WiFi</span>
                <span class="text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full">白板</span>
              </div>
            </div>

            <div class="price-tag">4万元/半天</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FatjHome",
  mounted () {
// 人数选择按钮交互
    document.querySelectorAll('.capacity-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        // 移除所有按钮的active状态
        document.querySelectorAll('.capacity-btn').forEach(b => {
          b.classList.remove('active');
        });
        // 为当前点击的按钮添加active状态
        this.classList.add('active');
      });
    });
  }
}
</script>

<style scoped>
.page-content{
  padding-top: 20px;
  padding-bottom: 20px;
}
body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #F9FAFB;
  color: #1F2937;
}

.container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 20px;
}

.card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.capacity-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 2px solid #E5E7EB;
  background-color: white;
  color: #4B5563;
}

.capacity-btn.active {
  border-color: #2563EB;
  background-color: #2563EB;
  color: white;
}

.capacity-btn:hover:not(.active) {
  border-color: #93C5FD;
  color: #2563EB;
}

.price-tag {
  background: linear-gradient(135deg, #2563EB 0%, #204E9C 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.25rem;
  text-align: center;
  margin-top: auto;
  transition: transform 0.3s ease;
}

.card:hover .price-tag {
  transform: translateY(-2px);
}

.feature-icon {
  color: #2563EB;
  background-color: #DBEAFE;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  overflow: hidden;
  height: 240px;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.card:hover .image-container img {
  transform: scale(1.05);
}

.badge {
  background-color: #EBF5FF;
  color: #2563EB;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
}

.my-banner {
  background: linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%);
  color: white;
  padding: 60px 20px;
  border-radius: 16px;
  margin-bottom: 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.my-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  z-index: 0;
}

.my-banner-content {
  position: relative;
  z-index: 1;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1F2937;
}
</style>
